import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/localstorage/localstorage.service';

@Injectable({ providedIn: 'root' })
export class CerrarSesionService implements OnDestroy {
  private timeoutMs = 10 * 60 * 1000;
  private timerId: any = null;

  private readonly activityEvents = [
    'mousemove', 'mousedown', 'keydown', 'scroll', 'click', 'touchstart', 'wheel'
  ] as const;

  private readonly boundReset = this.resetTimer.bind(this);

  constructor(
    private zone: NgZone,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {
    this.startWatching();
  }

  setTimeoutMinutes(min: number) {
    this.timeoutMs = Math.max(1, min) * 60 * 1000;
    this.resetTimer();
  }

  private startWatching() {
    this.zone.runOutsideAngular(() => {
      this.activityEvents.forEach(evt =>
        window.addEventListener(evt, this.boundReset, { passive: true })
      );
    });
    this.resetTimer();
  }

  private resetTimer() {
    if (this.timerId) clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      this.zone.run(() => this.forceLogout());
    }, this.timeoutMs);
  }

  private async forceLogout() {
    const token = this.localStorageService.getAccessToken();
    if (token) {
      try {
        await this.localStorageService.cerrarSesionBoveda(token);
      } catch (error) {
        console.error(error);
      }
    }
    this.localStorageService.clearToken();
    this.router.navigate(['/conade/autenticacion/signin']);
  }

  private stopWatching() {
    this.activityEvents.forEach(evt =>
      window.removeEventListener(evt, this.boundReset as any)
    );
    if (this.timerId) clearTimeout(this.timerId);
    this.timerId = null;
  }

  ngOnDestroy() {
    this.stopWatching();
  }
}
